import { render } from "./MessageRequests.vue?vue&type=template&id=012113b9&scoped=true"
import script from "./MessageRequests.vue?vue&type=script&lang=js"
export * from "./MessageRequests.vue?vue&type=script&lang=js"

import "./MessageRequests.vue?vue&type=style&index=0&id=012113b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012113b9"]])

export default __exports__